module.exports = __webpack_public_path__ + "static/media/meter1.f38d1a89.svg";